import { useAtom } from 'jotai';

import { selectedTeamIdAtom } from '~teacher/components/Account/atoms/selectedTeamIdAtom';
import { useTeams } from '~teacher/hook/team';

/**
 * This returns the data of the currently selected team.
 */
export function useSelectedTeamQuery() {
  const [selectedTeamId] = useAtom(selectedTeamIdAtom);

  return useTeams({
    select: (data) => data.find(({ id }) => `${id}` === `${selectedTeamId}`),
  });
}

export function useSelectedTeamRoleQuery() {
  const [selectedTeamId] = useAtom(selectedTeamIdAtom);

  return useTeams({
    select: (data) =>
      data.find(({ id }) => `${id}` === `${selectedTeamId}`)?.role,
  });
}
